/**
 * Formularz danych do faktury dla Usług Płatnych Cyklicznie
 * Obsługuje pola związane z danymi nabywcy, w szczególności:
 * - przełączanie typu identyfikatora podatkowego (NIP, NUMER ID, BRAK ID)
 * - zapewnia sterowanie wymagalnością pól formularza
 */
app.service('subscriptionServiceBuyerInvoice', function (regon) {

	function init(props) {

		let $self, $taxIdTypeSelector, $taxIdTypeBoxes, $invoiceAddress, $userName, $companyName, $nip, $numberId, $numberIdCountryCode;

		const {$form, onChange} = props;

		setElements($form);
		setEvents($form, onChange);

		function setElements($form) {
			$self = $form.find('.invoice-data');
			$taxIdTypeSelector = $self.find('input[name="invoiceData.taxIdType"]');
			$taxIdTypeBoxes = $self.find('.tax-id-type-box');
			$invoiceAddress = $self.find('.invoice-address-box').find('input:not([name="invoiceData.address.flatNumber"]), textarea');
			$userName = $self.find('input[name="invoiceData.firstName"], input[name="invoiceData.lastName"]');
			$companyName = $self.find('input[name="invoiceData.companyName"]');
			$nip = $self.find('input[name="invoiceData.nip"]');
			$numberId = $self.find('textarea[name="invoiceData.numberId"]');
			$numberIdCountryCode = $self.find('input[name="invoiceData.numberIdCountryCode"]');
		}

		function setEvents($form, onChange) {

			$form.find('.select3-input').select3();

			$numberIdCountryCode.on('change', function () {
				$form.validate().element($numberIdCountryCode);
			});

			$self.on('change', `input[name="invoiceData.taxIdType"]`, function handleTaxIdentifierChange() {
				onChange({invoiceTaxIdType: $(this).val()});
			});

			$numberId.prev('[contenteditable]').on('input', function () {
				$numberId.val($(this).text());
				$form.validate().element($numberId);
			});

			$self.find('.select3-input').select3();
			$self.find('input[name="invoiceData.address.zipCode"]').mask2('99-999').keyfilter(/[\d\-]/);

			autocompleteDelivery(
				$self.find('input[name="invoiceData.address.zipCode"]').attr('id'),
				$self.find('input[name="invoiceData.address.city"]').attr('id')
			);

			regon.init({
				$box: $self.find('.regon-box'),
				$nip: $self.find('input[name="invoiceData.nip"]'),
				$companyName: $self.find('input[name="invoiceData.companyName"]'),
				$city: $self.find('input[name="invoiceData.address.city"]'),
				$street: $self.find('input[name="invoiceData.address.street"]'),
				$houseNumber: $self.find('input[name="invoiceData.address.houseNumber"]'),
				$flatNumber: $self.find('input[name="invoiceData.address.flatNumber"]'),
				$zipCode: $self.find('input[name="invoiceData.address.zipCode"]')
			});
		}

		function setTaxIdTypeBox(props) {

			$taxIdTypeBoxes
				.removeClass('active')
				.filter((i, el) => el.dataset.type === props.invoiceTaxIdType)
				.addClass('active');

			updateFieldsValidation(props);
		}

		function setFieldState($field, shouldBeDisabled) {
			if ($field.prop('disabled') !== shouldBeDisabled) {
				$field.prop('disabled', shouldBeDisabled).ignore(shouldBeDisabled);
			}
		}

		function updateFieldsValidation(props) {
			const {isCompanyUserType, invoiceTaxIdType} = props;
			const companyFieldDisabled = !isCompanyUserType;

			setFieldState($userName, isCompanyUserType);
			setFieldState($companyName, companyFieldDisabled);
			setFieldState($taxIdTypeSelector, companyFieldDisabled);
			setFieldState($nip, companyFieldDisabled || invoiceTaxIdType !== 'NIP');
			setFieldState($numberId, companyFieldDisabled || invoiceTaxIdType !== 'NUMBER_ID');
			setFieldState($numberIdCountryCode, companyFieldDisabled || invoiceTaxIdType !== 'NUMBER_ID');
		}

		function render(props) {

			setTaxIdTypeBox(props);
		}

		return {
			render
		};
	}

	return {
		init
	};
});